const pushToDataLayer = (data: Record<string, any>) => {
	window.dataLayer = window.dataLayer || []
	window.dataLayer.push(data)
	console.log('GA4 dataLayer push:', data)
}

// Step 1: Fires when user completes signup (Auth0 form submitted + email verified)
export const trackAccountCreation1 = (params: {
	user_id: string
	email: string
	name: string | null
}) => {
	pushToDataLayer({
		event: 'account_creation_1',
		user_id: params.user_id,
		email: params.email,
		name: params.name
	})
}

// Step 2: Fires when user submits the "get started" form (website + ad spend)
export const trackGetStarted2 = (params: {
	website: string
	monthly_spend: number
	workspace_id: string
}) => {
	pushToDataLayer({
		event: 'get_started_2',
		website: params.website,
		monthly_spend: params.monthly_spend,
		workspace_id: params.workspace_id
	})
}

// Step 3: Fires when user reaches the plans/book demo screen
export const trackPlansOrBookDemo3 = () => {
	pushToDataLayer({
		event: 'plans_or_book_demo_3'
	})
}

// Step 3.1: Fires when a demo booking is successfully submitted
export const trackBookingSchedule31 = (params?: {
	date?: string
}) => {
	pushToDataLayer({
		event: 'booking_schedule_3_1',
		...(params?.date ? { date: params.date } : {})
	})
}

export const trackWebsiteAdded = (params: {
	workspace_id: string
	website: string
}) => {
	pushToDataLayer({
		event: 'website_added',
		workspace_id: params.workspace_id,
		website: params.website
	})
}

export const trackLeadFreeTrial = (params: {
	payment_method: string
	value: number
	currency: string
	transaction_id: string
	plan_name: string
	plan_price: number
	billing_cycle: string
	items: Array<{
		item_id: string
		item_name: string
		price: number
		quantity: number
	}>
}) => {
	pushToDataLayer({
		event: 'lead_free_trial',
		payment_method: params.payment_method,
		value: params.value,
		currency: params.currency,
		transaction_id: params.transaction_id,
		plan_name: params.plan_name,
		plan_price: params.plan_price,
		billing_cycle: params.billing_cycle,
		items: params.items
	})
}
